import { useEffect } from 'react';
import { capitalizeFirstLetter } from '@knapsack/utils';
import { sendUiEvent } from '@/core';

export function useKsMetaTags(
  {
    title,
    description,
  }: {
    title?: string | string[];
    description?: string;
  } = {
    title: '',
    description: '',
  },
): void {
  const cleanTitle = [...(Array.isArray(title) ? title : [title])]
    .filter(Boolean)
    .map(capitalizeFirstLetter)
    .join(' | ');

  useEffect(() => {
    sendUiEvent({
      type: 'headTags.set',
      headTags: {
        title: cleanTitle,
        description,
      },
    });
  }, [description, cleanTitle]);
}
